import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { Sun, Moon, ChevronLeft, ChevronRight } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { useFullscreen } from '../context/FullscreenContext';
import { useTranslation } from '../context/LanguageContext';

const MainLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  const { isFullscreen } = useFullscreen();

  return (
    <div className="flex h-screen bg-slate-50 dark:bg-black text-slate-900 dark:text-white overflow-hidden transition-colors duration-300">
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} hide={isFullscreen} />
      <main className={`flex-1 flex flex-col relative transition-all duration-300 md:ml-0 overflow-auto ${isFullscreen ? 'max-h-screen' : ''}`}>
        {/* Theme Toggle Buttons - hidden in fullscreen mode */}
        {!isFullscreen && (
          <div className="fixed bottom-4 right-4 z-50 flex gap-2 p-1 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-full shadow-md">
            <button 
              onClick={toggleTheme}
              className={`p-2 rounded-full transition-all ${theme === 'light' ? 'bg-slate-100 text-slate-700' : 'text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700'}`}
              title={t('sidebar.day_mode')}
            >
              <Sun size={18} />
            </button>
            <button 
              onClick={toggleTheme}
              className={`p-2 rounded-full transition-all ${theme === 'dark' ? 'bg-slate-700 text-white' : 'text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700'}`}
              title={t('sidebar.night_mode')}
            >
              <Moon size={18} />
            </button>
          </div>
        )}

        {/* Mobile Sidebar Toggle Button - hidden in fullscreen mode */}
        {!isFullscreen && (
          <button 
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="md:hidden fixed bottom-4 left-4 z-50 p-3 bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 transition-colors"
            title={isSidebarOpen ? t('sidebar.collapse_menu') : t('sidebar.expand_menu')}
          >
            {isSidebarOpen ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
          </button>
        )}
        
        <div className="p-3 md:p-8 flex-1">
          {children}
        </div>
        {!isFullscreen && (
        <footer className="p-4 bg-white dark:bg-gray-900 border-t border-slate-200 dark:border-gray-800 text-center text-slate-500 dark:text-slate-300 text-sm">
          &copy; {t('app.title')} {new Date().getFullYear()} - All Rights Reserved
        </footer>
        )}
      </main>
    </div>
  );
};

export default MainLayout;
